import { PropertyOption } from '@hb/domain';
import { PropertyStoreService } from '@hb/modules/property/property-store.service';
import { PropertyTypeComponent } from '@hb/modules/property/property-type';
import { EnergyLabelComponent } from '@hb/modules/property/energy-label';
import { RenovationPartComponent } from '@hb/modules/property/renovation-part/renovation-part.component';
import { PurchasePriceComponent } from '@hb/modules/property/purchase-price/purchase-price.component';
import { SustainabilityComponent } from '@hb/modules/property/sustainability/sustainability.component';
import content from '@hb/hypotheken-berekening.content.json';

import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';

import { PropertyType } from '@ap/ap-interface-apix-hypotheken-berekening';
import { ApContentModule, ApContentService } from '@ap/content';
import { ApRadioModule } from '@ap/radio';

@Component({
    selector: 'property',
    templateUrl: './property.component.html',
    standalone: true,
    imports: [
        ApContentModule,
        FormsModule,
        ReactiveFormsModule,
        AsyncPipe,
        ApRadioModule,
        PropertyTypeComponent,
        EnergyLabelComponent,
        PurchasePriceComponent,
        SustainabilityComponent,
        RenovationPartComponent
    ]
})
export class PropertyComponent implements OnInit {
    protected readonly store = inject(PropertyStoreService);
    protected readonly contentService = inject(ApContentService);

    activeOption: PropertyOption;
    protected readonly options = PropertyOption;
    protected readonly propertyType = PropertyType;

    ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.store.getActiveOption().subscribe((question) => {
            this.activeOption = question;
        });
    }
}
